import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import AudienceList from "./AudienceSelectionWithQuery"

export default class FieldRow extends Component {
  static propTypes = { label: PropTypes.string };

  render() {
    const { label, className, onChange,  ...rest } = this.props;
    return (
      <Wrapper className={className}>
        <Label>{label}</Label>
        <Colon>:</Colon>
        <Input>
          <AudienceList onChange={selected => onChange(selected) } />
        </Input>        
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
`;
const Label = styled.label`
  width: 60px;
  flex: none;
`;
const Colon = styled.div`
  margin-left: auto;
  margin-right: 14px;
`;
const Input = styled.div`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border: 1px solid ${props => props.theme.panelBorder};
  border-radius: 3px;
`;



// WEBPACK FOOTER //
// ./src/module-email-campaign/campaign/FieldRowWithAudience.js